import { render, staticRenderFns } from "./StudentAttendanceRecords.vue?vue&type=template&id=2ca66f85&"
import script from "./StudentAttendanceRecords.vue?vue&type=script&lang=js&"
export * from "./StudentAttendanceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports